"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealtimeMapUpdatesButton = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const hooks_1 = require("../../../store/hooks");
const mobileSessionsSlice_1 = require("../../../store/mobileSessionsSlice");
const realtimeMapUpdatesSlice_1 = require("../../../store/realtimeMapUpdatesSlice");
const media_1 = require("../../../utils/media");
const useScreenSizeDetection_1 = __importDefault(require("../../../utils/useScreenSizeDetection"));
const CheckboxButton_1 = require("../CheckboxButton/CheckboxButton");
const Toggle_1 = require("../Toggle/Toggle");
const S = __importStar(require("./RealtimeMapUpdatesButton.style"));
const RealtimeMapUpdatesButton = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const isMobile = (0, useScreenSizeDetection_1.default)(media_1.screenSizes.mobile);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const realtimeMapUpdates = (0, react_redux_1.useSelector)((state) => state.realtimeMapUpdates.realtimeMapUpdates);
    (0, react_1.useEffect)(() => {
        realtimeMapUpdates && dispatch((0, mobileSessionsSlice_1.clearMobileSessions)());
    }, [realtimeMapUpdates, dispatch]);
    const handleRealtimeMapUpdatesChange = (isChecked) => {
        dispatch((0, realtimeMapUpdatesSlice_1.setRealtimeMapUpdates)(isChecked));
    };
    return (react_1.default.createElement(S.RealtimeMapUpdatesButtonContainer, null, isMobile ? (react_1.default.createElement(Toggle_1.Toggle, { labelLeft: t("navbar.realtimeMapUpdates"), isChecked: realtimeMapUpdates, onChange: handleRealtimeMapUpdatesChange, variant: "toggle" })) : (react_1.default.createElement(CheckboxButton_1.CheckboxButton, { label: t("navbar.realtimeMapUpdates"), isChecked: realtimeMapUpdates, onChange: handleRealtimeMapUpdatesChange, staticColor: true }))));
};
exports.RealtimeMapUpdatesButton = RealtimeMapUpdatesButton;
